// extracted by mini-css-extract-plugin
export default {"hotspot":"Hotspot_hotspot__stQCZ","activeHotspot":"Hotspot_activeHotspot__rxpWQ"};